import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { useAuthStore } from '../store/authStore';

interface DashboardStats {
  total_opdrachten: number;
  active_opdrachten: number;
  completed_opdrachten: number;
  in_behandeling?: number;
  unread_messages?: number;
  total_professionals?: number;
  total_reviews?: number;
  action_items?: number;
  active_connections?: number;
  search_requests?: number;
  pending_dossier_acceptances?: number;
  reactie_professionals?: number;
}

export const useDashboardStats = () => {
  const { user } = useAuthStore();

  return useQuery({
    queryKey: ['dashboard-stats', user?.role],
    queryFn: async (): Promise<DashboardStats> => {
      if (user?.role === 'opdrachtgever' || user?.role === 'employer_member') {
        const response = await api.get('/employer/dashboard-stats');
        return response.data.data;
      } else if (user?.role === 'professional') {
        const response = await api.get('/professional/dashboard-stats');
        return response.data.data;
      }
      throw new Error('Invalid user role');
    },
    enabled: !!user && ['opdrachtgever', 'employer_member', 'professional'].includes(user.role || ''),
  });
};
